import { useState } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import type { Me } from "../lib/types";

export function Login() {
  const { user, needsSetup, setUser } = useAuth();
  const [params] = useSearchParams();
  const loc = useLocation();
  const joining = loc.pathname === "/join" || needsSetup;
  const [mode, setMode] = useState<"login" | "join">(joining ? "join" : "login");
  const [f, setF] = useState({ username: "", displayName: "", password: "", invite: params.get("code") ?? "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const r = await api<{ user: Me }>(mode === "login" ? "/auth/login" : "/auth/register", { body: f });
      setUser(r.user);
    } catch (e: any) { setErr(e.message); } finally { setBusy(false); }
  };
  const set = (k: keyof typeof f) => (e: React.ChangeEvent<HTMLInputElement>) => setF({ ...f, [k]: e.target.value });

  return <main className="page bare">
    <h1>Mathtrain</h1>
    <p className="mute">{needsSetup ? "Set up the first account. It becomes the admin and can invite everyone else."
      : mode === "login" ? "Mental math that adapts to you, with friends to keep you honest." : "Join with the invite code a member sent you."}</p>
    <form onSubmit={submit} style={{ marginTop: 24 }}>
      <label className="field"><span>Username</span><input autoComplete="username" autoCapitalize="none" value={f.username} onChange={set("username")} required /></label>
      {mode === "join" && <label className="field"><span>Display name</span><input value={f.displayName} onChange={set("displayName")} placeholder="Shown on leaderboards" /></label>}
      <label className="field"><span>Password</span><input type="password" autoComplete={mode === "login" ? "current-password" : "new-password"} value={f.password} onChange={set("password")} required minLength={mode === "join" ? 8 : 1} /></label>
      {mode === "join" && !needsSetup && <label className="field"><span>Invite code</span><input value={f.invite} onChange={set("invite")} autoCapitalize="characters" required /></label>}
      <div className="error" role="alert">{err}</div>
      <button className="btn-primary" disabled={busy}>{mode === "login" ? "Sign in" : needsSetup ? "Create admin account" : "Join"}</button>
    </form>
    {!needsSetup && <button className="btn quiet" style={{ marginTop: 12 }} onClick={() => { setMode(mode === "login" ? "join" : "login"); setErr(""); }}>
      {mode === "login" ? "Have an invite code? Join" : "Already have an account? Sign in"}
    </button>}
  </main>;
}
